export default __webpack_public_path__ + "static/media/pastajpg.25a561c9.jpg";